import React from 'react';
import { useDialogTransition } from './hook/useDialogTransition';

export const DialogWrapper = ({
  show,
  duration = 300,
  delay = 0,
  children,
  keepMounted = false,
}) => {
  const { shouldRender, isAnimating } = useDialogTransition(show, duration);

  if (!shouldRender && !keepMounted) return null;

  return (
    <div style={{ overflow: 'hidden' }}>
      <div
        style={{
          transition: `transform ${duration}ms ease ${delay}ms, opacity ${duration}ms ease-out ${delay}ms`,
          transform: isAnimating ? 'translateY(0)' : 'translateY(-110%)',
          opacity: isAnimating ? 1 : 0,
        }}
      >
        {children}
      </div>
    </div>
  );
};
